import { h } from 'preact'
import { useState } from 'preact/hooks'
import { ArticleFeedback } from './ArticleFeedback.jsx'
import { t } from '../beacon-i18n.js'

/**
 * ArticleReaderScreen — cikk beágyazva iframe-be, saját fehér fejléccel
 * (cím + nagyítás/kicsinyítés + X), lásd plan "Cikkolvasó (ArticleReaderScreen)".
 *
 * Draws its own header instead of the shared purple BeaconPanel header —
 * BeaconPanel skips its header entirely for screen === 'guide_article'.
 */
export function ArticleReaderScreen({ store }) {
  const [loaded, setLoaded] = useState(false)
  const slug  = store.articleSlug.value
  const title = store.articleTitle.value
  const isCompactViewport = store.isCompactViewport.value
  const isExpanded = store.panelSize.value === 'expanded'

  const src = `${store.identity.guideBaseUrl}/cikk/${encodeURIComponent(slug)}/?embed=1`

  function handleClose() {
    store.closeArticle()
  }

  return (
    <div class="beacon-article-reader">
      <div class="beacon-article-header">
        <span class="beacon-article-title">{title}</span>
        <div class="beacon-article-header-actions">
          {!isCompactViewport && (
            <button
              type="button"
              class="beacon-article-resize-btn"
              aria-label={isExpanded ? t('support.beacon.article.collapse_aria') : t('support.beacon.article.expand_aria')}
              onClick={() => store.togglePanelSize()}
            >
              <i class={`bi beacon-resize-icon ${isExpanded ? 'bi-arrows-angle-contract' : 'bi-arrows-angle-expand'}`}></i>
            </button>
          )}
          <button type="button" class="beacon-article-close-btn" aria-label={t('support.beacon.article.close_aria')} onClick={handleClose}>
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
      </div>

      <div class={`beacon-article-iframe-wrap ${loaded ? 'loaded' : ''}`}>
        {!loaded && <div class="beacon-article-skeleton"></div>}
        <iframe
          src={src}
          loading="lazy"
          title={title}
          onLoad={() => setLoaded(true)}
        ></iframe>
      </div>

      <ArticleFeedback slug={slug} title={title} />
    </div>
  )
}
